
export interface DetectLanguageRequest {
    input: string;
}

export type DetectLanguageResponse = 'CN' | 'EN' | string;

/**
 * 检测语言
 */
export interface DetectLanguageApi {
    /**
     * 检测语言
     * @param data 检测语言请求
     * @returns 检测语言响应，返回语言代码（如 'CN', 'EN', 'KO', 'JA' 等）
     */
    detectLanguage(data: DetectLanguageRequest): Promise<DetectLanguageResponse>;
}

export const DetectLanguageApi = Symbol('DetectLanguageApi');
